import { render, staticRenderFns } from "./newIndex.vue?vue&type=template&id=59970a7a&scoped=true&"
import script from "./newIndex.vue?vue&type=script&lang=js&"
export * from "./newIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59970a7a",
  null
  
)

export default component.exports